import React, { useMemo, useState, createContext, useContext } from 'react';
import type { AuthenticatedUser } from '../data/contracts';
interface AuthContextType {
  user: AuthenticatedUser | null;
  isAuthenticated: boolean;
  setAuthenticatedUser: (user: AuthenticatedUser) => void;
  clearAuthenticatedUser: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
interface AuthProviderProps {
  children: React.ReactNode;
}
export function AuthProvider({
  children
}: AuthProviderProps) {
  const [user, setUser] = useState<AuthenticatedUser | null>(null);
  const value = useMemo(() => ({
    user,
    isAuthenticated: user !== null,
    setAuthenticatedUser: setUser,
    clearAuthenticatedUser: () => setUser(null)
  }), [user]);
  return <AuthContext.Provider value={value} data-id="element-657">{children}</AuthContext.Provider>;
}